import React from 'react';
import PropTypes from 'prop-types';

// manor
import { Link } from '@comparethemarketau/manor-link';

import { withNavigateToMoreInfoPage } from './with_navigate_to_more_info_page';

const _SeeAllInclusions = (props) => {
    const { productId, navigateToMoreInfoPage } = props;
    const handleClick = (e) => {
        e.preventDefault();
        navigateToMoreInfoPage(productId);
    };

    return (
        <Link
            trackingLabel={`See all inclusions for productId: ${productId}`}
            underline="none"
            handleClick={handleClick}
        >
            See all inclusions
        </Link>
    );
};

_SeeAllInclusions.propTypes = {
    productId: PropTypes.string,
    navigateToMoreInfoPage: PropTypes.func
};

const SeeAllInclusions = withNavigateToMoreInfoPage(_SeeAllInclusions);

export { SeeAllInclusions };
